import { useUserStore } from '../../stores/user.store'
import type { Permission } from '../models/user'

export const usePermission = () => {
  const userStore = useUserStore()

  const can = (permission: Permission): boolean => {
    if (!userStore.user || !userStore.user.memberPermissions) {
      return false
    }
    return userStore.user.memberPermissions.includes(permission)
  }

  const canAny = (permissions: Permission[]): boolean => {
    return permissions.some((p) => can(p))
  }

  return { can, canAny }
}
